import { supabase } from './supabase';
import { logAppError } from './logAppError';

export async function callRpc<T = any>(
  name: string,
  params?: Record<string, any>,
  context?: string
): Promise<T> {
  const { data, error } = await supabase.rpc(name, params);
  
  if (error) {
    await logAppError({
      source: 'supabase_rpc',
      statusCode: 500, // Usually RPC errors fail as 500 or constraint violations
      path: `rpc/${name}`,
      method: 'RPC',
      message: error.message || error.details || error.hint || 'RPC Error',
      context,
    });
    throw error;
  }
  
  return data as T;
}
